import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=0005b4ed&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=0005b4ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005b4ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0005b4ed')) {
      api.createRecord('0005b4ed', component.options)
    } else {
      api.reload('0005b4ed', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=0005b4ed&scoped=true&", function () {
      api.rerender('0005b4ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/ProductCard.vue"
export default component.exports